export enum CalendarEventType {
  FileDate = 'filed',
  TradeDate = 'trade',
  StreetResearchBegins = 'research',
  LockupDate = 'lockups',
  PostponedWithdrawn = 'pw',
  OfferDate = 'offerDate',
}
